import { configurationSettings } from '../../../../configuration/configuration-settings';
import { getOrderSeatSelectionLimitsPerAreaCategory } from './get-order-seat-selection-limits-per-area-category';
export const getOrderSeatSelectionLimitsForShowtime = (showtimeId, areaCategoryIds) => {
    return {
        min: 1,
        max: configurationSettings.data.order.maximumTicketsPerOrder,
        limitsPerAreaCategory: getOrderSeatSelectionLimitsPerAreaCategory(showtimeId, areaCategoryIds)
    };
};
